export default "__VITE_ASSET__673WRdHw__"